import { RichText } from 'prismic-reactjs';
import { IWelcomeToOurTeam } from './interfaces';
import { careersHtmlSerializer } from '../../../utils/htmlSerializers/careersHtmlSerializer';
import {
  Grid,
  ImageContainer,
  ImagesContainer,
  Inner,
  PlayButton,
  Section,
  Title,
  VideoImageContainer,
} from './welcomeToOurTeam.styles';
import Image from 'next/image';
import { imageSerializer } from 'utils/imageSerializer';
import { PlayIconWhite } from 'components/images/PlayImages/PlayImages';
import Integration from '../Integration';
import { useMeetingVideo } from '../Integration/useMeetingVideo';

export const WelcomeToOurTeam = ({
  title,
  titleAs,
  description,
  mainImage,
  images,
}: IWelcomeToOurTeam) => {
  const { handlePlayVideo, isFullscreen, handleClose, videoRef } =
    useMeetingVideo();
  return (
    <Section>
      <Inner>
        <Title as={titleAs}>{title}</Title>
        <RichText render={description} htmlSerializer={careersHtmlSerializer} />
        <Grid>
          <VideoImageContainer>
            <Image {...imageSerializer(mainImage)} />
            <PlayButton onClick={handlePlayVideo}>
              <PlayIconWhite />
            </PlayButton>
          </VideoImageContainer>
          <Integration
            ref={videoRef}
            isFullscreen={isFullscreen}
            handleClose={handleClose}
          />
          <ImagesContainer>
            {images.map(({ welcome_image }, index) => (
              <ImageContainer key={index}>
                <Image {...imageSerializer(welcome_image)} />
              </ImageContainer>
            ))}
          </ImagesContainer>
        </Grid>
      </Inner>
    </Section>
  );
};
